import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_new.png'
import _imports_1 from '@/assets/images/icon/portrait.png'


const _withScopeId = n => (_pushScopeId("data-v-32c81c4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "header-title__logo"
    })
  ])
], -1))
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "header-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = {
  class: "el-dropdown-link",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  alt: "",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_11 = {
  class: "header-dropdown__name",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_12 = {
  key: 0,
  class: "pageBox-empty"
}
const _hoisted_13 = {
  key: 1,
  class: "pageBox-list"
}
const _hoisted_14 = ["infinite-scroll-disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pageBox-li__round" }, null, -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "pageBox-li__date" }
const _hoisted_18 = {
  key: 0,
  class: "pageBox-text"
}
const _hoisted_19 = {
  key: 1,
  class: "pageBox-text"
}
const _hoisted_20 = { class: "pageBox-footer" }

import { ArrowDown, EditPen, Back, Lock, BellFilled } from '@element-plus/icons-vue'
import { ref, getCurrentInstance, reactive, onMounted, computed, onBeforeUnmount } from 'vue'
import { useMainStore } from '@/stores/main'
import { getnotify, notifyAlready } from '@/api/workBench'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import changePassword from './changePassword.vue'
import ChannelConfirmation from './ChannelConfirmation.vue'
import { getDateDay } from '@/utils/common'
import { ElMessage } from 'element-plus'
import { getMeInfo } from '@/api/myProfile'
import { getAbbrLang, getMenuTitle } from '@/utils/lang'


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  emits: ['onFlodMenu'],
  setup(__props, { emit }) {

// import { useToggle } from '@vueuse/shared'
// import { isDark } from '@/style/theme/composables/dark'
const router = useRouter()
const { proxy } = getCurrentInstance() as any
const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const store = useMainStore()

const { menuInfo, activeMenu, activePage, businessTypeId, USER_INFO } = storeToRefs(store)


// 修改密码
const changepwd = ref<boolean>(false)
// 关闭弹窗
const onchange = (params: boolean) => {
  changepwd.value = params
}

// 未读消息
const isShowDrawer = ref(false)
const notifyScrollLoading = ref(false) // 无限滚动loading
const notifyList = ref<any[]>([])
const notifyTotal = ref(0) // 总数
const notifyNoMore = computed(() => notifyList.value.length >= notifyTotal.value) // 没有更多信息了
const notifyDisabled = computed(() => notifyScrollLoading.value || notifyNoMore.value) // 无线滚动disabled
const alreadyLoading = ref(false) // 全部已读按钮loading
const notifyData = reactive({
  is_deal: -1,
  current_page: 1,
  per_page: 30
})
// 获取新消息 ，type有值代表定时器
const getNotifyList = (type?: number) => {
  notifyScrollLoading.value = true
  if (type) {
    notifyData.current_page = 1
  }
  getnotify(notifyData).then(async (res: any) => {
    if (res.code === 200) {
      // 定时器查询新消息，从0开始
      if (type) {
        notifyList.value = []
      }
      for (let i = 0; i < res.data.data.length; i++) {
        res.data.data[i].created_at = await getDateDay(new Date(res.data.data[i].created_at))
        notifyList.value.push(res.data.data[i])
      }
      notifyData.current_page += 1
      notifyTotal.value = res.data.total
    }
    notifyScrollLoading.value = false
  }).catch(() => {
    notifyScrollLoading.value = false
    // 如果获取新消息失败，停止定时器，30min后再开启定时器，避免错误多次弹出Elmessage
    clearInterval(timer.value)
    times.value = setTimeout(() => {
      intervalGetNotify()
    }, 1800000)
  })
}
// 消息中心
const onMessageCenter = () => {
  isShowDrawer.value = false
  activeMenu.value = ''
  router.push({
    path: '/messageList'
  })
}

// 全部已读
const onRead = (type: string, batch_code?: string, index?: any) => {
  if (!notifyList.value.length) return
  alreadyLoading.value = true
  const ids: string[] | [] = type === 'item' && batch_code ? [batch_code] : []
  notifyAlready(ids).then((res: any) => {
    if (res.code === 200) {
      if (type === 'item') {
        notifyList.value.splice(index, 1)
        notifyTotal.value = notifyTotal.value--
        isShowDrawer.value = false
        router.push({
          path: '/messageDetails',
          query: { id: batch_code }
        })
      } else {
        // 全部已读
        notifyList.value = []
        notifyTotal.value = 0
      }
    } else {
      ElMessage.error(res.msg)
    }
    alreadyLoading.value = false
  }).catch(() => {
    alreadyLoading.value = false
  })
}

// 定时器，隔180s获取一次新消息
const timer = ref<any>(null) // setInterval
const times = ref<any>(null) // 异常定时器settimeout
const intervalGetNotify = () => {
  if (times.value) {
    times.value = null
    clearTimeout(times.value)
  }
  timer.value = setInterval(() => {
    if (isShowDrawer.value) return
    getNotifyList(1)
  }, 180000)
}
// 用户信息
const userName = ref('')
const userNameimg = ref('')
// 获取用户信息
const getUserInfo = () => {
  getMeInfo().then((res: any) => {
    if (res.code === 200) {
      USER_INFO.value = res.data
      openDialogFn(res.data.is_control)
      userName.value = res.data.username || ''
      userNameimg.value = res.data.avatar ? process.env.VUE_APP_OSS_ENDPOINT + res.data.avatar : ''
    }
  })
}

onBeforeUnmount(async () => {
  clearInterval(timer.value)
  clearTimeout(times.value)
})
// 切换暗黑主题
// const toggleDark = useToggle(isDark)

// 切换一级菜单
const onChangeMenu = (item: any) => {
  if (item.meta.type === 'TYPE_LINK') {
    window.open(item.path, '_blank')
    return
  }
  activeMenu.value = item.name
  businessTypeId.value = item.application_type_id
  if (item.children && item.meta.redirect_path) {
    // console.log(item.meta.redirect_path)
    router.push({
      name: item.meta.redirect_path
    })
    emit('onFlodMenu')
    activePage.value = item.meta.redirect_path
  } else {
    router.push(item.path)
  }
}
const handleUser = (command: string) => {
  // 退出
  if (command === 'outLogin') {
    proxy
      .$confirm(t('common.exitText'), t('common.tips'), {
        type: 'warning',
        confirmButtonText: t('common.exit'),
        cancelButtonText: t('common.Cancel')
      })
      .then(() => {
        proxy.$API.logout().then((res:any) => {
          if (res.code === 200) {
            proxy.$TOOL.cookie.remove('TOKEN_frontend')
            USER_INFO.value = {}
            proxy.$message.success(t('common.outLogin'))
            proxy.$router.push({ path: '/login' })
          }
        })
      })
      .catch(() => {
        // 取消退出
      })
  } else if (command === 'change') {
    changepwd.value = true
  } else if (command === 'user') {
    router.push({
      path: '/myProfile'
    })
  }
}

// 语言切换
const lang = ref(localStorage.getItem('LANG') ? localStorage.getItem('LANG') : proxy.$CONFIG.LANG)
// 保存语言
if (!localStorage.getItem('LANG')) {
  localStorage.setItem('LANG', lang.value)
}
const onChangeLang = (value: string) => {
  const data = {
    lang: value
  }
  proxy.$API.switchLang(data).then((res:any) => {
    if (res.code === 200) {
      localStorage.setItem('LANG', value)
      // lang.value = value
      // proxy.$i18n.locale = value
      // proxy.$TOOL.data.set('LANG', value)
      location.reload()
    }
  })
}
// *************************************************渠道商信息确认弹框相关操作*******************************************
const confirmDialog = ref(false)
// 打开弹框
const openDialog = (booleanstatues: boolean) => {
  confirmDialog.value = booleanstatues
}
// 判断是否打开弹窗
const openDialogFn = (satus:any) => {
  if (satus === 1) {
    openDialog(true)
  }
}
onMounted(async () => {
  await getNotifyList()
  intervalGetNotify()
  getUserInfo()
  if (!businessTypeId.value) {
    for (let i = 0; i < menuInfo.value.length; i++) {
      const element: any = menuInfo.value[i]
      if (element.application_type_id === activeMenu.value) {
        businessTypeId.value = element.application_type_id
        break
      }
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuInfo), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (onChangeMenu(item)),
              class: _normalizeClass(_unref(activeMenu) === item.name ? 'header-menu__active' : '')
            }, _toDisplayString(_unref(getMenuTitle)(item,_unref(t))), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_dropdown, {
          size: "large",
          class: "icon__lang"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeLang('zh_CN')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("简体中文")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onChangeLang('en')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("English")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onChangeLang('fr')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Français")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(getAbbrLang)(lang.value)) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDown))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "header-notify",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowDrawer.value=true))
        }, [
          _createVNode(_unref(BellFilled), { class: "icon__notify" }),
          (notifyList.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(notifyTotal.value), 1))
            : _createCommentVNode("", true)
        ]),
        (userNameimg.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: userNameimg.value,
              alt: "",
              style: {"width":"30px","height":"30px"}
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
        (!userNameimg.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dropdown, {
          size: "large",
          onCommand: handleUser
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "user" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(EditPen), { class: "icon__setting" }),
                    _createTextVNode(_toDisplayString(_unref(t)('common.AccountInformation')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "change" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Lock), { class: "icon__setting" }),
                    _createTextVNode(_toDisplayString(_unref(t)('common.ChangePassword')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  command: "outLogin"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Back), { class: "icon__setting" }),
                    _createTextVNode(_toDisplayString(_unref(t)('common.LogOut')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_11, [
              _createTextVNode(_toDisplayString(userName.value) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDown))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(changePassword, {
      changepwd: changepwd.value,
      onOnchange: onchange
    }, null, 8, ["changepwd"]),
    (confirmDialog.value)
      ? (_openBlock(), _createBlock(ChannelConfirmation, {
          key: 0,
          onOpenDialog: openDialog
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      modelValue: isShowDrawer.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowDrawer).value = $event)),
      direction: "rtl",
      size: "40%",
      "modal-class": "pageBox-drawer"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.newMessage')), 1)
      ]),
      default: _withCtx(() => [
        (!notifyList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_el_empty, {
                description: _unref(t)('common.noMessage')
              }, null, 8, ["description"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _withDirectives((_openBlock(), _createElementBlock("ul", { "infinite-scroll-disabled": _unref(notifyDisabled) }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifyList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "pageBox-li"
                  }, [
                    _hoisted_15,
                    _createElementVNode("div", {
                      class: "pageBox-li__title",
                      onClick: ($event: any) => (onRead('item', item.batch_code, index))
                    }, _toDisplayString(item.content), 9, _hoisted_16),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.created_at), 1)
                  ]))
                }), 128)),
                (notifyScrollLoading.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(t)('customsClearance.productConformity.loading')), 1))
                  : _createCommentVNode("", true),
                (_unref(notifyNoMore) && notifyList.value.length > 30)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(t)('common.noMore')), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14)), [
                [_directive_infinite_scroll, getNotifyList]
              ])
            ]))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onMessageCenter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.messageCenter')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onRead('all'))),
            disabled: !notifyList.value.length,
            loading: alreadyLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.allRead')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})